export enum ECommonProcessState {
  Initial,
  Starting,
  Started,
  Processing,
  Stopping,
  Stopped,
  Finished,
  Fault,
}
